export default __webpack_public_path__ + "static/media/b4y0_desktop.78c14a90.jpeg";